/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalServiceCategoryPlatform extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalServiceCategoryPlatform");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalServiceCategoryPlatform.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalServiceCategoryPlatform>): BillingRuleAllocationProportionalServiceCategoryPlatform {
        let obj = Object.assign(new BillingRuleAllocationProportionalServiceCategoryPlatform(), model);
        BillingRuleAllocationProportionalServiceCategoryPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalServiceCategoryPlatform>): BillingRuleAllocationProportionalServiceCategoryPlatform {
        if (!model) return null;
        return BillingRuleAllocationProportionalServiceCategoryPlatform.newInstance(<BillingRuleAllocationProportionalServiceCategoryPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalServiceCategoryPlatform) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalServiceCategoryPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalServiceCategoryPlatform): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalServiceCategoryPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of service categories to allocate by
     */
    service_categories: Array<string>;

}
